export default __webpack_public_path__ + "static/media/tete68.ac8439b0.png";